/**
 * Hex-Farbe zu CSS-Gradient konvertieren (aus V1 übernommen).
 * Erzeugt einen 135°-Gradient – standardmäßig heller, optional dunkler.
 */
export function colorToGradient(color: string, lighter = true): string {
  const hex = color.replace('#', '');

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  if (lighter) {
    const r2 = Math.min(255, r + 30);
    const g2 = Math.min(255, g + 30);
    const b2 = Math.min(255, b + 30);
    return `linear-gradient(135deg, rgb(${r}, ${g}, ${b}) 0%, rgb(${r2}, ${g2}, ${b2}) 100%)`;
  }

  const r2 = Math.max(0, r - 30);
  const g2 = Math.max(0, g - 30);
  const b2 = Math.max(0, b - 30);
  return `linear-gradient(135deg, rgb(${r}, ${g}, ${b}) 0%, rgb(${r2}, ${g2}, ${b2}) 100%)`;
}
